module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3732270cfcc864cbbd939ae7213f1a5a.svg";